module.exports = __webpack_public_path__ + "assets/ic-nova.e0761073.svg";